export enum SearchField {
    Source = 0,
    Target = 1
}

export interface SegmentSearchRequest {
    documentId: number;
    searchText: string;
    searchField: SearchField;
    page: number;
    pageSize: number;
    displayPageSize: number;
}

export interface SegmentSearchResultItem {
    translationSegmentId: number;
    segmentNumber: number;
    sourceText: string;
    targetText: string;
    displayPageNumber: number;
}

export interface SegmentSearchResponse {
    results: SegmentSearchResultItem[];
    totalCount: number;
    hasMore: boolean;
}
